module.exports = __webpack_public_path__ + "static/media/down-caret.edfe0baa.svg";